export default {
  open: false,
  images: [],
}
